import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import ContactUs from "./pages/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import TermsConditions from "./pages/TermsConditions";
import "./App.css";
import AboutUs from "./pages/AboutUs";
import Services from "./pages/Services";
import GrievancePolicy from "./pages/GrievancePolicy";
import ApiSolutions from "./pages/ApiSolutions";
import MobileDthRecharge from "./pages/MobileDthRecharge";
import UtilityBillPayments from "./pages/UtilityBillPayments";
import NsdlPanCardService from "./pages/NsdlPanCardService";
import UtiPanCardService from "./pages/UtiPanCardService";
import InsuranceService from "./pages/InsuranceService";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
        <Route path="/grievance-policy" element={<GrievancePolicy />} />

        <Route path="/api-solutions" element={<ApiSolutions />} />
        <Route
          path="/mobile-and-dth-recharge"
          element={<MobileDthRecharge />}
        />
        <Route
          path="/utility-bill-payments"
          element={<UtilityBillPayments />}
        />
        <Route path="/nsdl-pan-card-service" element={<NsdlPanCardService />} />
        <Route
          path="/offline-pan-card-service"
          element={<UtiPanCardService />}
        />
        <Route path="/insurance-service" element={<InsuranceService />} />
      </Routes>
    </Router>
  );
}

export default App;
